import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

import question from '../question/index.vue'
import coursePreview from "../../courses/preview/index.vue";


var fps = 25

export default {
    name: 'story',
    props: {
        id : String,
        composedStory : Object,
        closeWhenEnd : Boolean,
        wnd : Boolean,
        autoplay : Boolean,
        fromtime : Number,
        topmodal : Boolean,
        nocontrols : Boolean,
        showCourse : Boolean,
        silencemode : Boolean,
        circle : Boolean,
        podcast : Boolean,
        sharelink : String,
        noback : Boolean
    },

    data : function(){

        return {
            loading : true,
            resloading : true,
            story : null,
            error : null,
            activeScene : 0,
            audio : {},
            ticker : null,
            playing : false,
            //paused : true,
            time : 0,
            f,
            //TODO
            viewSend : false,
            hasreaction : false,
            fragmentLength : 50,
            answered : {},
            hiddenPause : false,
            delayedPreload : [],
            imagesPreloadedCache : {},
            course : null,
            silencemodeCancel : false,
            currentAudioSegments : []
        }

    },

    created(){
    },

    components : {
        question,
        coursePreview
    },

    beforeDestroy(){
        this.destroy()
    },

    watch: {
        id : {
            immediate : true,
            handler : function(){
                this.destroy()
                this.create()
                this.load()
            }
        },

        muted : function(){
            _.each(this.audio, (a, index) => {
                a.audio.muted = this.muted
            })
        },

        resloading : function(){

        },

        playing : function(){
            this.manageAudio()

            this.status()
        },

        hasmodalsUpHere: function(){
            this.manageAudio()

            this.status()
        },

        fromtime : function(){
            this.time = this.fromtime

            this.manageAudio(this.time, true)

            this.play()

        },

        time : function(){

            if(!this.story) return

            this.manageAudio(this.time)
            this.manageScene(this.time)
            this.manageDelayedPreload(this.time)

            if (this.time >= this.story.duration){

                this.end()

                if (this.closeWhenEnd) 
                    this.$emit('close')
            }

            

            if (this.auth && this.time >= this.story.duration / 2 && !this.viewSend && this.playing && !this.composedStory){
                
                if(!this.silencemode || this.silencemodeCancel){
                    this.viewSend = true
                    this.core.api[this.apipoint][this.auth ? 'view' : 'viewua'](this.id)
                    ///
                }
                
            }

            
        },

        textPosition : function(){
            if(this.story && !this.story.circle){
                if (this.char && f.isEmoji(this.char) ){
                    this.emojieffect(this.char, {
                        size : 20
                    })
                }
            }
        },

        ended : function(){
            if (this.ended && !this.closeWhenEnd){

                if(this.silencemode && !this.silencemodeCancel){
                    this.repeat()
                }
                else{

                    this.$emit('end', {
                        answered : this.answered,
                        questions : this.story.questions
                    })
                    
                }

                
            }
        }

        
    },
    computed: mapState({
        apipoint : function(){
            if (this.podcast){
                return 'podcasts'
            }

            return 'stories'
        },
        hasmodalsUpHere : function(){
            return this.modals.length && !this.topmodal
        },
        modals : state => state.modals,
        auth : state => state.auth,
        mobileview : state => state.mobileview,
        muted : function(state) {

            if(this.silencemode){
                if(!this.silencemodeCancel){
                    return true
                }
            }

            return state.muted
        },
        noimagesinstory : state => state.noimagesinstory,
        buttonsblock : function(state){
            return state.buttonsblock
        },

        inplaylist : function(state) {

            if(this.playlist){
                return this.playlist.ids.indexOf(this.id) > -1
            }

            return false
        },
        playlist : state => {
            return state.playlist
        },
        progress : function(){

            if(!this.story){
                return 0
            }

            return (this.time / this.story.duration).toFixed(5)
        },

        textprogress : function(){

            if(!this.story){
                return 0
            }

            return (Math.min(1, Math.max(0, this.time - this.story?.intro?.duration || 0) / this.story.textduration)).toFixed(5)

            
        },

        bganims : function(){

            if(this.mobileview){
                return ['centerright', 'centerleft']
            }

            return ['topcenter', 'bottomcenter']
        },

        ended : function(){

            if(!this.story) return false

            return this.time == this.story.duration
        },

        content : function(){
            if(!this.story){
                return ''
            }

            return this.story?.content
        },

        contentArray : function(){
            return Array.from(this.content)
        },

        textPosition : function(){
            if(!this.story){
                return 0
            }


            return Number((this.textprogress * this.content.length).toFixed(0))
            
        },

        char : function(){
            return this.contentArray[this.textPosition]
        },

        currentFragment : function(){
            var l = Math.max(0, this.textPosition - this.fragmentLength)
            var h = Math.min(this.contentArray.length - 1, this.textPosition + this.fragmentLength)

            return this.content.substring(l, h)
        },

        currentFootnote : function(){

            if(!this.story?.footnotes) return null

            if(this.story?.scenes?.[this.activeScene]?.intro) return null
            if(this.story?.scenes?.[this.activeScene]?.out) return null

            if(this.currentSceneIsQuestion) return null

            var fnc = _.filter(_.map(this.story.footnotes, (fn) => {

                if(fn.titleInSource){

                    var i = this.content.toLowerCase().indexOf(fn.titleInSource.toLowerCase())

                    if (i > -1){
                        return {
                            footnote : fn,
                            index : i
                        }
                    }

                    return null
                }

            }), (f) => {
                return f
            })

            if(!fnc.length) return null


            fnc = _.map(_.sortBy(_.filter(fnc, (v) => {

                return Math.abs(v.index - this.textPosition) < this.fragmentLength

            }), (v) => {
                return Math.abs(v.index - this.textPosition)
            }), (fn) => {
                return fn.footnote
            })


            return fnc[0]
        },

        currentSceneIsQuestion : function(){
            return this.story?.scenes?.[this.activeScene]?.question ? true : false
        },

        scenesWithQuestionsForProgressBar : function(){

            var scenes = []
            
            if(this.story) {
                scenes = _.map(_.filter(this.story.scenes, (s) => {
                    if(s.question) return true
                }), (s) => {

                    return {
                        start : s.start,
                        end : s.end,
                        answered : this.answered[s.question.index],
                        startp : s.start / this.story.duration,
                        endp : s.end / this.story.duration
                    }

                })
            }

            console.log('scenes', scenes, this.answered)

            return scenes

        }
    }),

    methods : {
        reaction : function(){

            this.heartEffect()

            if(this.hasreaction) return

            this.hasreaction = true
            
            this.core.api[this.apipoint].reaction(this.id, 5).catch(e => {
            })
        },
        create : function(){

            this.time = 0

            var lastTime = Date.now()

            this.ticker = setInterval(() => {

                var now = Date.now()

                var td = now - lastTime

                lastTime = now

                if(!this.story) return

                if(this.hasmodalsUpHere) return

                
                if (this.playing && !this.hiddenPause){
                    this.time = this.time + td / 1000
                }

                if (this.playing && this.time > this.story.duration){
                    this.time = this.story.duration
                }

            }, 1000 / fps)
        },

        destroy : function(){
            this.time = -1
            this.playing = false

            this.manageAudio(this.time)
            this.manageScene(this.time)

            if (this.ticker){
                clearInterval(this.ticker)
                this.ticker = null
            }

            _.each(this.audios, (a) => {
                a.destroy()
            })
            
            this.audio = {}
            this.error = null
            this.story = null
            this.activeScene = 0
            this.loading = true
            this.resloading = true
            this.hasreaction = false
            this.viewSend = false
            this.answered = {}
            this.hiddenPause = false
            this.delayedPreload = []
            this.imagesPreloadedCache = {}
            this.course = null
        },

       

        status : function(){

            var state = {
                playing : this.playing,
                time : this.time,
                ended : this.ended
            }

            console.log("STATUS", !this.silencemode || this.silencemodeCancel)

            if(!this.silencemode || this.silencemodeCancel){

                this.$emit('state', state)

                this.core.cordovakit.unsleep(this.playing)
            
                this.$store.commit('playingstory', this.playing && !this.hasmodalsUpHere ? {
                    ...state,
                    play : () => {
                        this.play()
                    },
                    pause : () => {
                        this.pause()
                    }
                } : null)

            }
            
        },
       
        bganimindex : function(index){
            return this.bganims[index % this.bganims.length]
        },

        manageDelayedPreload : function(time){

            _.each(this.delayedPreload, (d) => {
                if(d.time < time && !d.executed){
                    d.executed = true

                    d.promise().then(() => {
                        this.audioVolumeSetup()
                    })
                }
            })

        },

        manageScene : function(time){

            if(!this.story) return

            var na = _.findIndex(this.story.scenes, (scene) => {
                return scene.start <= time && scene.end > time
            })


            /////whenend

            if (na != this.activeScene) {
                
                if(this.activeScene < na){
                    if (this.story.scenes[this.activeScene]?.question && !this.answered[this.story.scenes[this.activeScene].question.index] && !this.inplaylist){
                        this.suspend()
                        return
                    }
                }

                this.activeScene = na

            }

        },

        getSeekTime : function(time){

            if(!this.story) return

            var t = null
            var blockt = null

            _.each(this.story.scenes, (scene) => {

                if(blockt || t){
                    return
                }

                if(scene.end < time){
                    if (scene.question && !this.answered[scene.question.index]){
                        blockt = scene.start
                    }
                }

                if(scene.start <= time && scene.end > time){
                    t = time
                }
            })

            if(time > this.story.duration && !blockt) return this.story.duration

            return blockt || t ? Math.min(this.story.duration, blockt || t) : null

        },

        manageAudio : function(time, seek){

            var inseg = []

            _.each(this.audio, (a, index) => {

                if (this.playing && (a.start <= time && time <= a.start + a.duration) /*&& time <= this.story.duration*/ && !this.hasmodalsUpHere && !this.ended){

                    if (a.audio.paused){

                        if (a.audio.duration != a.audio.currentTime){
                            if(this.silencemode && !this.silencemodeCancel){

                            }
                            else{

                                if(!a.startPlaying) {
                                    a.startPlaying = true

                                    a.audio.play().then(() => {
                                    }).catch(e => {
                                        console.error(e)
                                        this.pause()
                                    }).finally(() => {
                                        a.startPlaying = false
                                    })
                                }

                                

                            }
                            
                        }
                        
                    }

                    if (a.applygain){
                        a.applygain()
                    }

                    /*if (a.segments){

                    }*/
                    
                }
                else{

                    if(!a.audio.paused){
                        a.audio.pause()
                    }
                    else{
                        if(a.start > time) a.audio.currentTime = 0
                        if(a.start + a.duration < time) a.audio.currentTime = a.audio.duration
                    }
                }


                if (seek){
                    a.audio.currentTime = Math.max(time - a.start, 0)
                }


                if(!a.audio.paused && a.segments){
                    console.log("HERE")

                    _.each(a.segments, (s) => {
                        if(s.startTimeSeconds < time && s.endTimeSeconds >= time){
                            inseg.push(s)
                        }
                    })
                }
                
            })

            console.log('inseg', inseg)

            this.currentAudioSegments = inseg

        },
        clear : function(){

        },

        loadCourseInfo : function(){
            if (this.showCourse && this.story.course){
                this.core.api.lessons.get(this.story.course.uid).then((course) => {
                    this.course = course
                })
            }
        },

        load : function(){
            this.loading = true
            this.resloading = true
            
            var promise = null
            

            if(this.composedStory){
                promise = (() => {return Promise.resolve(this.composedStory)})()
            }
            else{
                promise = this.core.api[this.apipoint].get(this.id)
            }

            promise.then((story) => {
                this.story = story
                this.preloadRes()

                console.log('this.story', this.story)

                this.loadCourseInfo()

                if (this.fromtime && this.fromtime < story.duration){
                    this.time = this.fromtime
                }

                this.loadReaction()

            }).catch(e => {
                console.error(e)
                this.error = e
            }).finally(() => {
                this.loading = false
            })
        },

        loadReaction : function(){

            if(this.auth){

                this.core.api[this.apipoint].reactions([this.id]).then(reactions => {
                    if (reactions.length){
                        this.hasreaction = true
                    }
                }).catch(e => {
                    console.error(e)
                })

            }
        },

        audioVolumeSetup : function(){

            if(this.silencemode && !this.silencemodeCancel){
                return Promise.resolve()
            }

            var promises = []

            _.each(this.audio, (a, index) => {
                if(a.setUpVolume) return

                var audio = a.audio

                var audioContext = this.core.media.getAudioContext()
            
                const track = audioContext.createMediaElementSource(audio);
                const gainNode = audioContext.createGain();
                var analyser = null

                var needwarming = false

                if (this.time + 0.5 < a.start){
                    needwarming = true
                }

                if(this.silencemode && !this.silencemodeCancel){
                    needwarming = false
                }

                
                //audio.volume = 0.01

                a.setUpVolume = true

                track.connect(gainNode).connect(audioContext.destination);

                /*if(this.story.podcast){
                    analyser = audioContext.createAnalyser();
                    track.connect(analyser);
                    analyser.fftSize = 2048;
                    const bufferLength = analyser.frequencyBinCount;
                    dataArray = new Uint8Array(bufferLength);
                    const points = new Float32Array(32).fill(0);
                    const prevPoints = new Float32Array(32).fill(0);
                }*/
                

                if (needwarming){
                    
                    gainNode.gain.value = 0.01;

                    promises.push(audio.play().then(() => {
                        audio.pause()
                    }).catch(e => {
                        console.error(e, index)
                    }).finally(() => {
                        //audio.currentTime = 0
                        gainNode.gain.value = a.gainfunction();
                    }))
                }
                else{
                    gainNode.gain.value = a.gainfunction()
                }

                a.destroy = function(){
                    try {
                        track.disconnect();
                        gainNode.disconnect();

                        if (analyser)
                            analyser.disconnect();

                        audio.src = '';
                    } catch (e) {

                    }
                }

                a.applygain = function(){
                    gainNode.gain.value = a.gainfunction()
                }

                a.analyser = analyser
            })


            return Promise.all(promises)
            
        },

        initAudio : function(data, volume = 1){

            //

            var audio = new Audio(data.path || "");

            if (data.path){
                audio.preload = 'auto';
                audio.load()
            }
                
            audio.crossOrigin = true
            audio.autoplay = false
            audio.loop = false
            audio.muted = this.muted // false

            //if(this.muted) audio.muted = this.muted

            var destroy = function() {
                audio.src = '';
            };

            return new Promise((resolve, reject) => {

                console.log('addEventListener canplaythrough', data.path)

                if (data.path){
                    audio.addEventListener("canplaythrough", () =>{

                        console.log('canplaythrough', data.path)

                        setTimeout(() => {
                            if(!this.story){
                                return reject('destroyed')
                            }
                            resolve(audio)
                        }, this.story && this.story.circle ? 30 : 450)


                        
                        
                    }, { once: true })

                    audio.addEventListener('error', function(err){
                        reject(err)
                    })
                }
                else{
                    resolve(audio)
                }
                

            }).then(() => {

                var preinit = function(_data = {}){
                    return new Promise((resolve, reject) => {
                        if (data.path){
                            resolve()
                        }
                        else{
                            audio.src = _data.path
                            audio.preload = 'auto';
                            audio.load()

                            audio.addEventListener("canplaythrough", () =>{
                                setTimeout(() => {
                                    resolve(audio)
                                }, 450)
                            })

                            audio.addEventListener('error', function(err){
                                reject(err)
                            })
                        }
                    })
                }

                return Promise.resolve({audio, destroy, preinit, volume, segments : data.segments})
            })
            
        },

        setAudio : function({audio, destroy, preinit, volume, segments}, index, start = 0, duration){

            var duration = Math.min(
                duration || audio.duration, 
                this.story.duration - start
            )

            if (start + duration > this.story.duration){
                duration = this.story.duration - start
            }

            var gainfunction = () => {

                if(this.muted) return 0

                return volume
            }

            if(index == 'backgroundaudio'){
                gainfunction = () => {

                    if(this.muted) return 0

                    var d = 3
                    var starteffect = start + duration - d
                    var endeffect = start + duration

                    if(this.time > endeffect) return 0
                    if(this.time < starteffect) return volume

                    return volume * f.easy.easeOutCubic(1 - (this.time - starteffect) / d)
                }
            }

            this.$set(this.audio, index, {
                audio : audio,
                start,
                end : start + duration,
                duration,
                destroy,
                volume,
                preinit,
                gainfunction,
                segments
            })

        },

        preloadRes : function(){
            this.resloading = true
            var promises = []
            var canshowImage = false
            var canshowAudio = false
            var delayedPreload = []

            if(this.story.audio) {

                promises.push(
                    this.initAudio(this.story.audio).then((audio) => {

                        this.setAudio(audio, 'voiceover', this.story.audio.start || 0, this.story.audio.duration)

                        return Promise.resolve()
                    }).catch(e => {
                    })
                )
                
            }

            if(this.story.intro) {

                promises.push(
                    this.initAudio(this.story.intro).then((audio) => {

                        this.setAudio(audio, 'intro', this.story.intro.start || 0, this.story.intro.duration)

                        return Promise.resolve()
                    }).catch(e => {
                    })
                )
                
            }

            if(this.story.backgroundaudio) {

                promises.push(
                    this.initAudio(this.story.backgroundaudio, 0.15).then((audio) => {

                        this.setAudio(audio, 'backgroundaudio', this.story.backgroundaudio.start || 0, this.story.backgroundaudio.duration)

                        return Promise.resolve()
                    }).catch(e => {
                    })
                )
                
            }

            _.each(this.story.scenes, (scene, i) => {
                if(scene.image){

                    if(i < 1){
                        promises.push(

                            f.preloadImage(scene.image).then(() => {

                                

                                if(!i){
                                    canshowImage = true
                                }

                                return Promise.resolve()

                            }).catch(e => {

                                return Promise.resolve()
                                
                            }).finally(() => {
                                if (this.resloading) {
                                    this.resloading = !(canshowImage && canshowAudio)
                                }

                                this.$set(this.imagesPreloadedCache, scene.image, true)
                            })

                        )
                    }

                    else{
                        delayedPreload.push({
                            promise : () => {

                                this.$set(this.imagesPreloadedCache, scene.image, true)

                                return f.preloadImage(scene.image)
                            },
                            time : scene.start - 20,

                            executed : false,

                            type : 'image'
                        })
                    }

                    
                }
                else{
                    //return Promise.resolve()
                }
            })

            _.each(this.story.scenes, (scene, i) => {
                if(scene.audios){
                
                    _.each(scene.audios, (audio, j) => {
                        if(i < 2){
                            promises.push(
                                this.initAudio(audio, 1).then((caudio) => {

                                    this.setAudio(caudio, 'scenesAudio' + i + '_' + j, scene.start + audio.start)

                                    return Promise.resolve()
                                }).catch(e => {
                                })
                            )
                        }
                        else{
                            delayedPreload.push({
                                promise : () => {
                                    return this.initAudio(audio, 1).then((caudio) => {

                                        this.setAudio(caudio, 'scenesAudio' + i + '_' + j, scene.start + audio.start)

                                        return Promise.resolve()
                                    }).catch(e => {
                                    })
                                },
                                time : scene.start - 20,

                                executed : false,

                                type : 'audio'
                            })
                        }
                        
                    })
                    

                    
                }
                else{
                    return Promise.resolve()
                }
            })

            Promise.all(promises).then(() => {
                this.resloading = false
                this.manageAudio(this.time, true)

                if (this.autoplay){
                    setTimeout(() => {

                        if (this.core.focus){
                            this.play()
                        }
                        
                    }, 100)
                }
                
                
            })

            this.delayedPreload = delayedPreload
        },

       
        endedEffect : function(){


            var c = 0
            _.each(this.contentArray, (char) => {

                if (char && f.isEmoji(char)){
                    if(c > 3) return

                    c++

              

                    setTimeout(() => {
                        this.starsEffect({
                            size : 15,
                            duration : 2000
                        })
                    }, f.rand(0, 2000))

                    setTimeout(() => {
                        this.starsEffect({
                            size : 20,
                            duration : 1000
                        })
                    }, f.rand(1000, 3000))
                    
                }
            })
        },

        starsEffect : function(p = {}){

            if(this.noimagesinstory) return


            if (this.core.infinityEffect){
                this.core.infinityEffect.play('stars', {
                    size : 15,
                    scatter : 100,
                    opacity : 0.8,
                    color : '#ffa000',
                    
                    from : {
                        y : window.innerHeight - 50,
                        x : window.innerWidth / 2
                    },

                    to : {
                        y : window.innerHeight / 2,
                        x : window.innerWidth
                    },
                    ...p
                })
            }
        },

        heartEffect : function(p = {}){


            if (this.core.infinityEffect){
                this.core.infinityEffect.play('hearts', {
                    size : 15,
                    scatter : 100,
                    opacity : 0.95,
                    color : '#FF5757',
                    count : f.rand(60, 100),
                    from : {
                        y : window.innerHeight - 0.25 * window.innerHeight,
                        x : window.innerWidth / 2
                    },

                    to : {
                        y : 0,
                        x : window.innerWidth
                    },
                    ...p
                })
            }
        },

        emojieffect : function(symbol, {size, duration}){

            if(this.noimagesinstory) return

            if (this.core.infinityEffect){
                this.core.infinityEffect.play('emoji', {
                    symbol,
                    size : size || 20,
                    scatter : window.innerWidth / 3,
                    duration : duration || 4000,
                    from : {
                        y : window.innerHeight,
                        x : 0
                    },

                    to : {
                        y : window.innerHeight / 2,
                        x : window.innerWidth / 2
                    }
                })
            }
        },

        play : function(){
            this.audioVolumeSetup().then(() => {
                this.playing = true
                this.hiddenPause = false
            })
        },

        pause : function(){
            this.playing = false
        },

        suspend : function(){
            this.hiddenPause = true
        },

        resume : function(){
            this.hiddenPause = false
        },

        repeat : function(){

            this.answered = {} 
            this.time = 0
            this.manageAudio(this.time, true)
            this.play()
            /*this.playing = true
            this.hiddenPause = false*/
        },

        repeatclick : function(){
            this.repeat()
        },

        playclick : function(){

            var silenceModeExit = false

            if (this.silencemode && !this.silencemodeCancel){
                this.silencemodeCancel = true
                this.playing = false
                silenceModeExit = true
                
            }

            this.audioVolumeSetup().then(() => {

                if(silenceModeExit){
                    this.time = 0
                    this.manageAudio(this.time, true)
                    this.playing = true
                    this.status()
                }
                else{
                    this.playing = !this.playing
                }   
                


            })
            
        },
        
        toScene : function(index){
            this.time = 0 ///TODO
        },


        answer : function({question, answer}){

            this.$set(this.answered, question.index, answer)

            this.resume()
            this.next()
            this.play()
            
        },

        closePlaylist : function(){
            this.$store.commit('playlist', null)
            this.$router.push({name : 'index'})
        },

        createVideo : function(){
            this.core.api.moderation.createVideo(this.id).then(result => {
                if (result.path){

                    f.openlink(this.core.api.server + '/' + result.path)

                    return
                }

                this.$dialog.alert(
                    this.$t('snippity.videos.status.' + result.status), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })
            }).catch(e => {
                this.$dialog.alert(
                    JSON.stringify(e), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })
            })
        },

        wndclose : function(){
            this.pause()
            this.status()
        },

        close : function(){

            this.pause()
            
            setTimeout(() => {
                if(this.wnd){
                    this.$emit('close')
                }
                else{
                    this.$router.push({name : 'index'})

                }
            }, 20)
            
            
        },
    
        end : function(){

            this.status()
            this.pause()

            if(this.inplaylist){

                var next = null

                var myindex = this.playlist.ids.indexOf(this.id)

                if (myindex < this.playlist.ids.length - 1) {
                    next = this.playlist.ids[myindex + 1]
                }

                else{
                    if(this.playlist.settings.loop){
                        next = this.playlist.ids[0]
                    }
                }
                

                setTimeout(() => {

                    if(next){
                        if(next == this.id){
                            this.repeat()
                        }
                        else{

                            this.$router.push({name : 'story', params : {id : next}, query : {time : 0}})


                        }
                        
                    }
                    else{
                        this.closePlaylist()
                    }

                }, 400)

                ///TODO CHECK PLAYLIST END
            }

        },

        next : function(){

            if(!this.story) return

            var nextScene = this.activeScene + 1

            if (this.story.scenes[nextScene]){
                this.time = this.story.scenes[nextScene].start
            }
            else{
                this.time = this.story.duration
            }

            this.manageAudio(this.time, true)
        },

        back : function(){

            if(!this.story) return

            var nextScene = this.activeScene - 1

            if (nextScene >= 0){
                this.time = this.story.scenes[nextScene].start
            }
            else{
                this.time = 0
            }

            this.manageAudio(this.time, true)
        },

        nextback : function(e){

            if(this.story.circle || this.podcast) return

            if(this.buttonsblock || this.currentSceneIsQuestion) return

            if(e.pageX > window.innerWidth / 2){
                this.next()
            }
            else{
                this.back()
            }

            this.resume()
        },

        showFootnote : function(footnote){

            

            var duration = Math.max((footnote.audio && footnote.audio.duration ? (footnote.audio.duration + 0.5) : 0) || footnote.text.length / 18, 5)

            var composedStory = {
                content : footnote.text,
                audio : footnote.audio,
                duration,
                scenes : [
                    {
                        text : '<b>'+f.flb(footnote.title)+'</b><br>' + footnote.text,
                        duration,
                        start : 0,
                        end : duration,
                        image : footnote.image,
                        title : f.flb(footnote.title)
                    }
                ]
            }

            //var playing = this.playing

            //this.pause()

            this.core.vueapi.story({
                closeWhenEnd : true,
                composedStory,
                autoplay : true
            }, {
                close : () => {
                    /*if (playing){
                        this.play()
                    }*/
                }
            })
        },

        mute : function(){
            this.$store.commit('muted', !this.muted)
        },

        buttonsblockaction: function(){
            this.$store.commit('buttonsblock', !this.buttonsblock)
        },

        removeimages : function(){
            this.$store.commit('noimagesinstory', !this.noimagesinstory)
        },

        share : function(){
            this.core.vueapi.share({
                url : this.sharelink || ('https://' + this.core.domain + '/stories/' + this.id)
            })
        },

        openPlaylist : function(){

            if(!this.auth) return

            this.core.cordovakit.vibration()

            this.core.vueapi.playlist({
                story : {
                    id : this.id,
                    time : this.time
                }
            })
        },

        textVersion : function(){
            this.core.vueapi.storytext({
                story : this.story
            }, {
                
            })
        },

        openSettings : function(v){

            if(v) this.core.cordovakit.vibration()

            var items = []

            items.push({
                text: this.noimagesinstory ? 'caption.displayimages' : 'caption.dontdisplayimages',
                icon: this.noimagesinstory ? 'fas fa-eye-slash' : 'fas fa-eye',
                action: this.removeimages
            })

            items.push({
                text: this.muted ? 'caption.unmute' : 'caption.mute',
                icon: this.muted ? 'fas fa-volume-mute' : 'fas fa-volume-up',
                action: this.mute
            })

            if(this.auth && f.touchDevice()){
                if(this.playing || this.buttonsblock){
                    items.push({
                        text: this.buttonsblock ? 'caption.unblock' : 'caption.block',
                        icon: this.buttonsblock ? 'fas fa-lock' : 'fas fa-lock-open',
                        action: this.buttonsblockaction
                    })
                }
            }

            if(!this.story.course && !this.podcast){
                items.push({
                    text: 'snippity.playlist',
                    icon: 'fas fa-list-ol',
                    action: this.openPlaylist
                })
            }

            

            if (this.inplaylist){

                items.push({
                    text: 'snippity.playlistclose',
                    icon: 'fas fa-arrow-left',
                    action: this.closePlaylist
                })
            }


            

            if(this.core.user.checkFeatures(['promo'])){
                items.push({
                    text: 'snippity.createVideo',
                    icon: 'fa-solid fa-video', 
                    action: this.createVideo
                })
            }

            //var playing = this.playing

            //this.pause()

			this.core.vueapi.listmenu(items, {
                close : () => {
                    //if(playing) this.play()
                }
            })
        },

        clickProgressBar : function(e){
            const bar = e.currentTarget // это <div class="progress">
            const rect = bar.getBoundingClientRect()
            const clickX = e.clientX - rect.left
            const newProgress = Math.min(Math.max(clickX / rect.width, 0), 1)

            var t = this.getSeekTime(this.story.duration * newProgress)

            if (t) {
                this.time = t
                this.manageAudio(this.time, true)
            }
        },

        silencemodeEnabled : function(){
            if(this.silencemode && !this.silencemodeCancel) return true

            return false
        },

        characterInSegment : function(character){
            return _.find(this.currentAudioSegments, (s) => {
                if(character.name == s.character){
                    return true
                }
            }) ? true : false
        }
    },

    /*sceneActions_sendLesson : function(scene){

        var course = this.course || this.story?.course

        
       
    }*/
}